import { inject } from '@angular/core';
import {
  Router,
  UrlTree,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  CanDeactivateFn,
} from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { OrderExceptionsPage } from '../order-exceptions.page';
import { OrderExceptionService } from '../service/order-exception.service';

export const OrderExceptionsRouteGuard: CanDeactivateFn<OrderExceptionsPage> = (
  component: OrderExceptionsPage,
  route: ActivatedRouteSnapshot,
  currentState: RouterStateSnapshot,
  nextState: RouterStateSnapshot,
): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const orderExceptionService = inject(OrderExceptionService);
  const currentRoute = currentState?.url;
  const targetUrl = nextState?.url;
  console.log('Checking Order Exceptions Guard');

  try {
    if (
      !currentRoute.includes('exceptionId') &&
      ((currentRoute.includes('search?searchText') &&
        !currentRoute.includes('mode=addToListSearch') &&
        (targetUrl.endsWith('/order') ||
          targetUrl.includes('/my-orders') ||
          targetUrl.includes('/my-orders-view') ||
          targetUrl.endsWith('/home'))) ||
        (currentRoute.includes('/order-confirmation/') &&
          targetUrl.endsWith('/my-orders-view')) ||
        targetUrl.endsWith('/order') ||
        targetUrl.includes('/products/'))
    ) {
      return of(true);
    }

    if (!component?.resolveLaterClick) {
      return orderExceptionService.getOrderExceptionViewModel().pipe(
        switchMap(orders => {
          if (
            orders.orderExceptions.size > 0 &&
            !currentRoute.includes('addToListSearch')
          ) {
            if (
              targetUrl.endsWith('/order') ||
              targetUrl.includes('/order/submitted-order/') ||
              targetUrl.includes('/order-confirmation/') ||
              targetUrl.includes('/products/') ||
              targetUrl.endsWith('/my-orders-view') ||
              targetUrl.endsWith('/my-orders') ||
              targetUrl.endsWith('/home')
            ) {
              orderExceptionService.confirmDeactivate(currentRoute, targetUrl);
              return of(router.parseUrl(currentRoute));
            } else {
              return of(true);
            }
          } else {
            return of(true);
          }
        }),
      );
    } else {
      component.resolveLaterClick = false;
      return of(true);
    }
  } catch (err) {
    return of(true);
  }
};
